const api = document.querySelector("[data-js='feapi']");

if (api) {
  const foldOutInput = document.querySelector("#f-search-location");
  let altSearchResult = document.querySelector(".alternative-search-result");
  let altSearchResultButton = document.querySelector(
    ".alternative-search-result-button"
  );
  let autoCompSearch = document.querySelector(".fold-out__autocomplete");

  function handleSubmit(event) {
    event.preventDefault();

    const data = new FormData(event.target);
    const value = JSON.stringify(Object.fromEntries(data.entries()));

    var url = "https://" + host + "/api.php?api=getPrice";
    console.log({ value });
    $.post(
      url,
      value,
      function (value, status) {
        if (status === "success") {
          $(value).each(function (index, element) {
            if (element.success == true) {
              //   console.log(element);
              altSearchResult.classList.remove("d-none");
              altSearchResultButton.classList.remove("d-none");
              $("#alternative-search-result-price").text(
                element.data.price_formatted
              );
            } else {
              // console.log(element);
              altSearchResult.classList.remove("d-none");
              $("#alternative-search-result-price").text(
                "Diese Buchung ist leider nicht möglich."
              );
            }
          });
        }
      },
      "json"
    );
  }
  const form = document.querySelector("#form-calculate-alternative");
  form.addEventListener("submit", handleSubmit);

  $("#submit-take_over").on("click", function (e) {
    e.preventDefault();

    var url = "/index.php?";
    var data = {
      unit: $("#form-search-location").val(),
      arrival: $("#form-search-arrival").val(),
      departure: $("#form-search-departure").val(),
      adults: $("#form-search-adults").val(),
      children: $("#form-search-children").val(),
      infants: $("#form-search-infants").val(),
      pets: $("#form-search-pets").val(),
    };
    var parameter = $.param(data);
    window.location.href = url + parameter;
  });
}
